import React from "react";
import { useNavigate } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";

export const Auth0ProviderWithNavigate = ({
  domain,
  clientId,
  redirectUri,
  children,
}) => {
  const navigate = useNavigate();

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      cacheLocation="memory"
      authorizationParams={{
        audience: window.env.REACT_APP_AUTH0_AUDIENCE,
        redirect_uri: redirectUri,
        scope: "openid profile email offline_access",
      }}
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
      onRedirectCallback={(appState) => {
        const returnTo =
          appState?.returnTo && appState.returnTo !== "/login"
            ? appState.returnTo
            : "/";

        navigate(returnTo, {
          replace: true,
        });
      }}
    >
      {children}
    </Auth0Provider>
  );
};
